import { useEffect, useState } from "react";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n2 } from "../../lib/format";
import DataTable from "../../lib/DataTable";
import { Notice, Stat } from "../../lib/ui";

/* Zero stock report – port of report_zero_stock.php (API: /api/stock/zero) */

export default function ZeroStock() {
  const api = useApi();
  const [d, setD] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { api.get("/api/stock/zero").then(setD).catch((e) => setError(e.message)); }, [api]);
  const columns = [
    { key: "product_id", label: "ID", num: true }, { key: "product_name", label: "Product", render: (r) => <b style={{ color: "var(--ink)" }}>{r.product_name}</b> },
    { key: "manufacturer", label: "Manufacturer" }, { key: "product_type", label: "Type" }, { key: "barcode", label: "Barcode" },
    { key: "purchase_price", label: "Purchase", num: true, render: (r) => n2(r.purchase_price) }, { key: "retail_price", label: "Retail", num: true, render: (r) => n2(r.retail_price) },
    { key: "minimum_stock", label: "Min stock", num: true },
  ];
  return (
    <main className="pg">
      <PageHeader slug="report_zero_stock" actions={<button type="button" className="btn" onClick={() => window.print()}><i className="fas fa-print" /> Print</button>} />
      <Notice notice={error && { tone: "err", text: error }} />
      {d && (
        <>
          <div className="ui-stats">
            <Stat icon="fa-box-open" tone="danger" label="Products out of stock" value={d.total} />
            <Stat icon="fa-industry" tone="muted" label="Manufacturers affected" value={d.manufacturers} />
            <Stat icon="fa-clock" tone="muted" label="Generated" value={<span style={{ fontSize: ".85rem" }}>{d.generated_at}</span>} />
          </div>
          {d.by_type.length > 0 && <section className="panel card-pad" style={{ marginBottom: "1.25rem" }}><h3>By product type</h3>
            <div style={{ display: "flex", flexWrap: "wrap", gap: ".4rem" }}>{d.by_type.map(([t, n]) => <span key={t} className="pill-tag err">{t}: {n}</span>)}</div></section>}
          <section className="panel"><DataTable columns={columns} rows={d.products} rowKey={(r) => r.product_id} searchPlaceholder="Search out-of-stock products" empty="No products are out of stock." /></section>
        </>
      )}
    </main>
  );
}
